import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client } from "./scoped-merchant-client";

export interface TikTokShopAuthResponse {
  merchantId: string;
  hasTikTokShopAuth: boolean;
  ttsRegion?: string;
}

export const useMerchantDetails = (merchantId: string) => {
  return useQuery({
    queryKey: ["merchant", merchantId, "details"],
    queryFn: async () => {
      const res = await client.merchant[":merchantId"].details.$get({ param: { merchantId } });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!merchantId, // Only run query if merchantId exists
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
